/* Copyright (c) 2020-present CloudIO Inc */

export function isDraggable(type: string) {
  return !['Page'].includes(type);
}
